import {createSlice} from "@reduxjs/toolkit";

const initialTransfersByAgentState = {
  loading: false,
  data: null,
  error: null,
};

export const transfersByAgentSlice = createSlice({
  name: "transfersByAgent",
  initialState: initialTransfersByAgentState,
  reducers: {
    fetchTransfers: (state, action) => {
      const {entities} = action.payload;
      state.loading = false;
      state.error = null;
      state.data = entities;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.loading = false;
    },
    startCall: (state) => {
      state.error = null;
      state.loading = true;
    },
  }
});
